import type { TFunction } from "i18next"
import { z } from "zod"

export const firstLoginSchema = (t: TFunction) =>
  z
    .object({
      email: z.string().email(t("validation.invalidEmail")),
      oldPassword: z
        .string()
        .min(1, t("validation.invalidTemporaryPassword")),
      password: z
        .string()
        .min(
          8,
          t("validation.passwordMinLength", { count: 8 })
        ),
      confirmPassword: z
        .string()
        .min(
          8,
          t("validation.passwordMinLength", { count: 8 })
        ),
    })
    .refine(
      (data) => {
        if (data.password !== data.confirmPassword) {
          return false
        }
        return true
      },
      {
        message: t("validation.passwordsMustMatch"),
        path: ["confirmPassword"],
      }
    )
    .refine(
      (data) => {
        const hasSpecialChar =
          /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(
            data.password
          )
        if (!hasSpecialChar) {
          return false
        }
        return true
      },
      {
        message: t("validation.passwordNeedsSpecialChar"),
        path: ["password"],
      }
    )
    .refine(
      (data) => {
        const hasNumber = /[0-9]/.test(data.password)
        if (!hasNumber) {
          return false
        }
        return true
      },
      {
        message: t("validation.passwordNeedsNumber"),
        path: ["password"],
      }
    )
    .refine(
      (data) => {
        const hasUpperCase = /[A-Z]/.test(data.password)
        if (!hasUpperCase) {
          return false
        }
        return true
      },
      {
        message: t("validation.passwordNeedsUppercase"),
        path: ["password"],
      }
    )

export type FirstLoginSchemaProps = z.infer<
  ReturnType<typeof firstLoginSchema>
>
